module.exports = "<img *ngFor=\"let url of urls; trackBy: index;\" #img [src]=\"url\" style=\"display:none;\" />"